import {ActionTree} from "vuex";
import {DataImplementationsWithMessagesCountState, DataImplementationsWithMessagesCount} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<DataImplementationsWithMessagesCountState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/data_implementations_with_messages_count', {params: params})
        .then((response: AxiosResponse) => {
          const dataImplementationsWithMessagesCounts: DataImplementationsWithMessagesCount[] = response.data;
          commit('setDataImplementationsWithMessagesCounts', dataImplementationsWithMessagesCounts);
          return {
            dataImplementationsWithMessagesCounts,
            page: parseInt(response.headers['x-page'], 10),
            perPage: parseInt(response.headers['x-per-page'], 10),
            total: parseInt(response.headers['x-total'], 10),
          }
        });
  }
}

export default actions;
